// extracted by mini-css-extract-plugin
export default {"root":"SignUp_root__KS4IK","inpContainer":"SignUp_inpContainer__v+BGB","buttonsContainer":"SignUp_buttonsContainer__TQA1r","orange":"SignUp_orange__EkooZ"};